// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 5H0V19H21V5ZM6 15H4V9H6V15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M24 15V9H22V15H24Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-battery-low-filled')
export default class BatteryLowFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'battery-low-filled',
    }
  }
}
